export const SHORTCUT_ICON_TEST_ID = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
export const SHORTCUT_DIVIDER_TEST_ID =
	'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
export const SHORTCUT_WRAPPER_TEST_ID =
	'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';
